<template>
  <div class="genetic-similarity-proximity-container">
    <div class="back-container">
      <BackButton :clickMethod="closePage" class="mb-3"/>
    </div>

    <SpinnerContainer v-if="this.$store.state.appConfig.isLoading"/>
    <div v-else class="proximity-container cs-scroll-style">
      <div class="proximity-container-header">
        <div class="image-container">
          <b-img  class="mx-auto detail-image" :src="dataSample.logoUrl" />
        </div>
        <div>
          <h4>{{ $tPop(dataSample.code, 'title',  dataSample.title) }}</h4>
        </div>
      </div>

      <div class="proximity-container-item">
        <h5>{{$tI('Description title')}}</h5>
        <hr/>
        <div>
          <p class="description" v-html="formattedDescription"></p>
        </div>
      </div>

      <div class="distance-container">
        <table class="table table-striped distance-table">
          <thead class="table-light">
              <tr>
                <th scope="col">{{$tI('Distance title')}}</th>
                <th scope="col">{{$tI('Modern population title')}}</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="distanceItem in distanceList" :key="distanceItem.title">
                <td><span class="td-size" :style="{ color: distanceItem.gradHSL }"> {{ distanceItem.distance }}</span></td>
                <td>{{$t(distanceItem.title.replaceAll('*', ' '))}}</td>
              </tr>
          </tbody>
        </table>
      </div>

      <div class="proximity-container-item">
        <h5>{{ $tI('Source') }}</h5>
        <hr/>
        <div class="meta-data">
          <div class="text-font-size">
            <p class="" >
                <b >{{ $tI('Date title') }}:</b> {{ tData }}
            </p>
            <p class="mt-2">
                <b >{{ $tI('Y-DNA') }}:</b> {{dataSample.yDna}}
            </p>
            <p class="mt-2">
              <b >{{ $tI('mtDNA') }}:</b> {{dataSample.mtDna}}
            </p>
            <p class="mt-2">
              <b >{{ $tI('Location title') }}:</b> {{ $t(dataSample.location) }}
            </p>
            <p class="mt-2">
              <b >{{ $tI('Research title') }}:</b> 
              <ResearchLink :researchLinkContent="researchArray"/>
            </p>
            <p class="mt-2">
              <b>{{ $tI('Sample title') }}:</b> {{dataSample.samples}}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import BackButton from '@/components/ui/BackButton.vue';
import proximityDistanceWatcher from '../services/proximityDistanceWatcher'
import { tDateParser } from '@/services/Base/utils'

export default {
  components: {
    BackButton,
  },
  data() {
    return {
    };
  },
  methods: {
    closePage() {
      this.$store.state.ancientProxResult.isOpenedAncientProxDetail = false;
      this.$store.state.ancientProxResult.openedAncientProxDetail =  { id: 0, };
    },
  },
  computed: {
    dataSample() {
      return this.$store.state.ancientProxResult.openedAncientProxDetail;
    },
    researchArray() {
      const research = this.dataSample.research;
      if (research || research !== '') {
        const pattern = /<\/?[a-z][\s\S]*>/i;
        if (pattern.test(research)) {
          return research;
        }

        const researchArray = research ? research.split('\n') : [];
        return researchArray
                        .map((res) => `<a href="${res}" class="researchlink" target="_blank">${res}</a>`)
                        .join(", ");
      }
      return null;
    },
    formattedDescription() {
      const description = this.$tPop(this.dataSample.code, 'description',  this.dataSample.desciption1);
      return description ? description.replace(/\n/g, '<br>') : '';
    },

    distanceList() {
      return this.$store.state.geneticSimilarities.proximityCalculatedResult;
    },

    tData() {
      let date = this.dataSample.date;

      if(date) {
        const dateObj = tDateParser(date);
        date = this.$tParams(dateObj.key, dateObj.params, dateObj.value, this.dataSample.date);
      }

      return date;
    }
  },
  mounted() {
    proximityDistanceWatcher.init();
  },
  beforeDestroy() {
    proximityDistanceWatcher.cleanup();
  },
};
</script>

<style lang="scss" scoped>
.genetic-similarity-proximity-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100vh;
  background-color: var(--white-100);

  .proximity-container {
    padding: 0 28px 28px 28px;
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .proximity-container-header {
    display: flex;
    align-items: center;
    justify-content: start;
    background-color: var(--bg-body-color);
    border-radius: 10px;
    .image-container {
      display: block;
      padding: 1rem 0.5rem;
      border-radius: 10px;

      img {
        height: 120px !important;
        width: 120px !important;
        border-radius: 10px;
      }
    }
  }
}
</style>